import { Component, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DOMAIN_ENVIRONMENT } from 'src/app/_services/base.service';
import { PlatformService } from 'src/app/_services/platform.service';
import { UsuarioService } from 'src/app/_services/usuario.service';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { BtnLinkComponent } from 'src/app/_shared/bloque-buttons/btn-link/btn-link.component';
import { DiasRestantesComponent } from 'src/app/_shared/bloque-ficha/dias-restantes/dias-restantes.component';
import { ProgressBarComponent } from 'src/app/_shared/bloque-ficha/progress-bar/progress-bar.component';
import { TagOverfundingComponent } from 'src/app/_shared/bloque-tags/tag-overfunding/tag-overfunding.component';
import { Minificha } from 'src/app/venture/shared/_models/minificha';
import { TagEstadoProyectoComponent } from 'src/app/venture/shared/utils/tag-estado-proyecto/tag-estado-proyecto.component';

@Component({
  selector: 'app-ficha-oportunidades',
  templateUrl: './ficha-oportunidades.component.html',
  styleUrls: ['./ficha-oportunidades.component.scss'],
  standalone: true,
  imports: [
    SharedModule,
    RouterModule,
    TagEstadoProyectoComponent,
    TagOverfundingComponent,
    DiasRestantesComponent,
    ProgressBarComponent,
    BtnLinkComponent
  ]
})


export class FichaOportunidadesComponent implements OnInit {
  @Input() totalOportunidades: number;
  @Input() oportunidad: Minificha;
  isLogged: boolean;
  platformId: string;
  domainUrl: string;

  constructor(private _usuarioService: UsuarioService, private _platformService: PlatformService) { }

  ngOnInit(): void {
    this.platformId = DOMAIN_ENVIRONMENT[this._platformService._domainEnvironment];
    this.domainUrl = this._platformService.getSubdominioUrl('venture');
    this.getSession();
  }

  private getSession(): void{
    this.isLogged = this._usuarioService.getSession() ? true : false;
  }
}
